import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//Components
import { HeaderComponent } from './header/header.component';
import { MissionComponent } from './mission/mission.component';
import { ProductComponent } from './product/product.component';
import { FooterComponent } from './footer/footer.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { FormComponent } from './form/form.component'
import { TargetProductComponent } from './target-product/target-product.component';
//Modules
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule, MatProgressBarModule, MAT_DATE_LOCALE } from '@angular/material/';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SocialCardComponent } from './social-card/social-card.component';
import { PopoverComponent } from './popover/popover.component';
import { CustomsignupComponent } from './customsignup/customsignup.component';


@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        RouterModule,
        MatMenuModule,
        MatIconModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatAutocompleteModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialFileInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressBarModule,
        MatCheckboxModule
    ],
    declarations: [
        HeaderComponent,
        MissionComponent,
        ProductComponent,
        FooterComponent,
        BreadcrumbsComponent,
        FormComponent,
        TargetProductComponent,
        SocialCardComponent,
        PopoverComponent,
        CustomsignupComponent
    ],
    exports: [
        HeaderComponent,
        MissionComponent,
        ProductComponent,
        FooterComponent,
        BreadcrumbsComponent,
        FormComponent,
        TargetProductComponent,
        SocialCardComponent,
        PopoverComponent,
        CustomsignupComponent
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-GB' },
    ],
    entryComponents: [PopoverComponent]
})

export class ComponentsModule { }